<p
  *ngIf="validationErrorOnSubmit"
  [id]="id"
  role="alert"
  class="sr-only"
  aria-atomic="true"
>
  {{ message }}
</p>
